import { requireGuest } from "@/features/auth";
import { type AuthSearch, guestRedirectFor, validateAuthSearch } from "@/features/auth/auth-search";
import { Outlet, createFileRoute } from "@tanstack/react-router";

// Check ./login/index.ts for route
export const Route = createFileRoute("/login")({
  validateSearch: (search): AuthSearch => validateAuthSearch(search),
  beforeLoad: async ({ search }) => {
    await requireGuest(guestRedirectFor(search));
  },
  component: Outlet,
});
